module.exports = __webpack_public_path__ + "img/icon_service_05.3569ab0c.png";